/**
 * @generated SignedSource<<5098e8639caf31e8f7d8a346888daedf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Payment_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCharge_query">;
  readonly " $fragmentType": "Payment_query";
};
export type Payment_query$key = {
  readonly " $data"?: Payment_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"Payment_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Payment_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCharge_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "af99683824f86e78c1700d13ba36a8da";

export default node;
